import React from 'react';
import DynamicIcon from '../../../components/UI/DynamicIcon/DynamicIcon';
import { appendReferralParams } from '../../../shared/utility';
import styles from './SavedTicketBanner.module.scss';

const SavedTicketBanner = ({ goldenFact, onRedeem }) => {
    const hasLink = goldenFact?.linkUrl && goldenFact.linkUrl !== '#';
    const destinationUrl = hasLink ? appendReferralParams(goldenFact.linkUrl) : null;
    const ticketIcon = goldenFact?.ticketIconName || 'IconTicket';

    if (hasLink) {
        return (
            <a
                href={destinationUrl}
                target="_blank"
                rel="noopener"
                className={styles.bannerButton}
                style={{ textDecoration: 'none' }}
            >
                <span className="d-flex align-items-center justify-content-center bg-black bg-opacity-15 rounded-circle shadow-sm" style={{ width: '36px', height: '36px' }}>
                    <DynamicIcon name={ticketIcon} size={20} color="var(--bs-dark, #212529)" strokeWidth={2} />
                </span>
                <span className="flex-grow-1 fw-bold small text-dark lh-sm text-start">{goldenFact?.buttonText || 'Gewinn-Ticket einlösen'}</span>
                <span className="small text-dark fw-bold">→</span>
            </a>
        );
    }

    return (
        <button type="button" onClick={() => onRedeem()} className={styles.bannerButton}>
            <span className="d-flex align-items-center justify-content-center bg-black bg-opacity-15 rounded-circle shadow-sm" style={{ width: '36px', height: '36px' }}>
                <DynamicIcon name={ticketIcon} size={20} color="var(--bs-dark, #212529)" strokeWidth={2} />
            </span>
            <span className="flex-grow-1 fw-bold small text-dark lh-sm text-start">{goldenFact?.buttonText || 'Gewinn-Ticket einlösen'}</span>
            <span className="small text-dark fw-bold">→</span>
        </button>
    );
};

export default SavedTicketBanner;
